module.exports = __webpack_public_path__ + "img/yxqd.5d540022.png";